<template>
  <div>
    <div class="image-container mb-1 mt-2">
      <v-img width="104" height="40" contain :src="$asset('img/support.png')" />
    </div>
    <div class="mb-3">
      {{ $t('dashboard.supportBox.boxText') }}
    </div>
    <div>
      <SupportBox
        v-for="(supportBox, index) in supportBoxes"
        :key="index"
        :title="supportBox.title"
        :text="supportBox.text"
        :icon="supportBox.icon"
        :buttons="supportBox.buttons"
        :outage="supportBox.outage"
      />
    </div>
  </div>
</template>
<script>
import SupportBox from '@/components/Molecules/SupportBox.vue';
import customerService from '@/mixins/customerService';
export default {
  name: 'CustomerService',
  components: { SupportBox },
  mixins: [customerService]
};
</script>
<style>
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
